export default {
  getBudgetWatchLists: (state) => state.budgetWatchLists,
  selectedCategoryCodes: (state) => state.budgetWatchLists.map((b) => b.categoryCodeId),
};
